module.exports = __webpack_public_path__ + "static/media/firebase.288f8490.png";